<template>
  <div>
    <img :src="logoUrl" style="width: 115px">
    <form id="payment_form" method="POST" class="tdesk-form">
      <form-errors :errors="paymentErrors" />
      <input type="hidden" name="token">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>
              <span class="control-label">Card number</span>
              <div
                id="card-number-element"
                class="form-control"
                style="padding: 10px 10px 10px 10px; max-width: 500px;"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="row" style="min-width: 890px;">
        <div class="col-md-6" style="max-width: 425px;">
          <div class="form-group">
            <label>
              <span class="control-label">Expiry date</span>
              <div
                id="card-expiry-element"
                class="form-control"
                style="padding: 10px 10px 10px 10px; max-width: 500px;"
              />
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>
              <span class="control-label">CVC</span>
              <div
                id="card-cvc-element"
                class="form-control"
                style="padding: 10px 10px 10px 10px; max-width: 500px;"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="error" style="color: red;" />
      <button
        id="payment-btn"
        type="submit"
        class="tdesk-primary-button"
        :disabled="tokenSet"
      >
        <i class="fas fa-arrow-alt-circle-right" />
        Pay ${{ parseFloat(total).toFixed(2) }}
      </button>
      <div class="outcome">
        <div
          v-if="submitted"
          id="waiting-on-success"
          style="margin-top: 1.2rem"
        >
          <i class="fas fa-spinner fa-spin" />
          Processing Payment
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import FormErrors from "../../form_errors";

export default {
  components: { FormErrors },
  props: {
    logoUrl: {
      required: true,
      type: String,
    },
    paymentErrors: {
      required: true,
      type: Array,
    },
    stripePublicKey: {
      required: true,
      type: String,
    },
    courseTitle: {
      required: true,
      type: String,
    },
    total: {
      required: true,
      type: String,
    },
    order: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      errors: this.paymentErrors,
      tokenSet: false,
      submitted: false,
    };
  },
  watch: {
    paymentErrors: function() {
      this.tokenSet = false;
      this.submitted = false;
    },
  },
  mounted() {
    const $component = this;

    var stripe = window.Stripe(this.stripePublicKey);

    var elements = stripe.elements({
      fonts: [
        {
          cssSrc:
            "https://fonts.googleapis.com/css?family=Titillium+Web:300,300i,400,400i,600,600i,700&display=swap",
        },
      ],
    });

    var style = {
      base: {
        iconColor: "#666EE8",
        color: "#31325F",
        fontWeight: 300,
        fontFamily: "Titillium Web",
        fontSize: "15px",

        "::placeholder": {
          color: "#CFD7E0",
        },
      },
    };

    var cardNumberElement = elements.create("cardNumber", {
      style: style,
    });
    cardNumberElement.mount("#card-number-element");
    cardNumberElement.on("ready", function() {
      cardNumberElement.focus();
    });

    var cardExpiryElement = elements.create("cardExpiry", {
      style: style,
    });
    cardExpiryElement.mount("#card-expiry-element");

    var cardCvcElement = elements.create("cardCvc", {
      style: style,
    });
    cardCvcElement.mount("#card-cvc-element");

    function setOutcome() {
      var errorElement = $(".error");
      errorElement.hide();
      $component.tokenSet = false;
    }

    cardNumberElement.on("change", function(event) {
      setOutcome(event);
    });

    cardExpiryElement.on("change", function(event) {
      setOutcome(event);
    });

    cardCvcElement.on("change", function(event) {
      setOutcome(event);
    });

    var form = document.querySelector("#payment_form");

    form.addEventListener("submit", function(ev) {
      ev.preventDefault();

      if ($component.tokenSet === false) {
        stripe.createToken(cardNumberElement).then(rsp => {
          if (rsp.error) {
            return ($component.errors = [rsp.error.message]);
          }
          $component.errors = [];
          $component.handleSubmit(rsp.token.id);
        });
        $component.tokenSet = true;
      }
    });
  },
  methods: {
    handleSubmit(tokenId) {
      this.submitted = true;
      this.$nextTick(() => this.$emit("handle-submit", tokenId));
    },
  },
};
</script>
